
export const redireccionar = (url:string)=>{
    //window.location.href = url;
    window.open(url,'_self','noopener,noreferrer');
}